import axios from "axios";

export const axiosPostCall = async (url, formData, header) => {
  const response = await axios.post(url, formData, header);

  return response;
};

export const axiosFormPostCall = async (url, formData, formHeader) => {
  const response = await axios.post(url, formData, formHeader);

  return response;
};

const handleAxiosError = (error) => {
  // Handle errors here
  if (error.response) {
    console.error("Response data:", error.response.data);

    if (error.response.data === "jwt expired") {
      console.log("failed");

      // Clear all data from session storage
      sessionStorage.clear();

      // Reload the page
      window.location.reload();

      // After the page has reloaded, navigate to the root page
      window.location.href = "/";
    }
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error("Request setup error:", error.message);
  }
};

const getTokenFromEmail = () => {
  const storedToken = sessionStorage.getItem("token");
  return storedToken;
};

export const axiosPostCallWithToken = async (url, formData) => {
  const token = getTokenFromEmail();
  try {
    const response = await axios.post(url, formData, {
      headers: {
        "x-api-key": token,
      },
    });

    return response;
  } catch (error) {
    // Call the separate error handling function
    handleAxiosError(error);
  }
};

export const axiosGetCallWithToken = async (url, formData) => {
  const token = getTokenFromEmail();

  try {
    const response = await axios.get(url, {
      params: formData,
      headers: {
        "x-api-key": token,
      },
    });
    return response;
  } catch (error) {
    // Call the separate error handling function
    handleAxiosError(error);
  }
};

export const axiosPutCallWithToken = async (url, formData) => {
  const token = getTokenFromEmail();
  try {
    const response = await axios.put(url, formData, {
      headers: {
        "x-api-key": token,
      },
    });

    return response;
  } catch (error) {
    // Call the separate error handling function
    handleAxiosError(error);
  }
};

export const axiosDeleteCallWithToken = async (url) => {
  const token = getTokenFromEmail();
  try {
    const response = await axios.delete(url, {
      headers: {
        "x-api-key": token,
      },
    });

    return response;
  } catch (error) {
    // Call the separate error handling function
    handleAxiosError(error);
  }
};

export const axiosGetCall = (url, dataObj) => {
  return axios.get(url, dataObj);
};

export const axiosPutCall = (url, dataObj) => {
  return axios.put(url, dataObj);
};

export const axiosDeleteCall = (url, dataObj) => {
  return axios.delete(url, dataObj);
};
